export default "__VITE_ASSET__BCpJiMOV__"